<template>
  <q-page
    padding
    class="q-pt-lg"
  >
    <div
      v-if="loading"
      class="text-center q-ma-md"
    >
      <q-spinner-bars size="xl" />
    </div>
    <div class="q-pt-lg">
      <div class="row q-col-gutter-sm">
        <div
          v-for="flippingCard in flippingCards"
          :key="flippingCard.key"
          class="col-4"
        >
          <q-card class="bg-primary text-white full-height">
            <q-card-section class="float-right">
              <div class="text-h5">
                {{ flippingCard.label }}
              </div>
            </q-card-section>
            <q-card-section>
              <div class="text-h6">
                {{ flippingCard.caption }}
              </div>
            </q-card-section>
          </q-card>
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
import { getActivityResume } from '@/utils/api/admin'

export default {
  name: 'Resume',
  data () {
    return {
      loading: false,
      resumeActivitySimple: []
    }
  },
  computed: {
    chartOptions () {
      return {
        chart: {
          type: 'donut'
        }
      }
    },
    flippingCards () {
      return this.resumeActivitySimple.map((data) => ({
        key: data.key,
        label: data.value,
        caption: data.label,
        action: []
      }))
    }
  },
  created () {
    this._fetchData()
  },
  methods: {
    async _fetchData () {
      this.loading = true
      const { data: { simple } = {} } = await getActivityResume()
      this.resumeActivitySimple = simple
      this.loading = false
    }
  }
}
</script>

<style scoped>

</style>
